import React from "react"
import PropTypes from "prop-types"
import { compose } from "redux"
import classNames from "classnames"

// @material-ui/core
import CircularProgress from "@material-ui/core/CircularProgress"
import withStyles from "@material-ui/core/styles/withStyles"

import { loadingAnimationVariants } from "constants/internal"

import loadingAnimation from "lib/lotties/loading"
import Lottie from "../Lottie"
import styles from "./styles"

const Loading = ({
    classes,
    className,
    loading,
    transparent,
    variant,
    color,
    ...rest
}) => {
    const renderLoader = () => {
        switch (variant) {
            case loadingAnimationVariants.primary:
                return (
                    <CircularProgress
                        {...rest}
                        color="inherit"
                        className={classes.loader}
                    />
                )
            case loadingAnimationVariants.secondary:
                return (
                    <Lottie
                        loop
                        autoplay
                        animationData={loadingAnimation}
                        width={180}
                        height={180}
                    />
                )
            default:
                return (
                    <CircularProgress
                        {...rest}
                        color="inherit"
                        className={classes.loader}
                    />
                )
        }
    }

    return (
        <div
            className={classNames(
                classes.root,
                className,
                loading && classes.loading,
                transparent && classes.transparent,
                classes[color],
            )}
        >
            {renderLoader()}
        </div>
    )
}

Loading.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    /* set loading to false to hide the component without removing it from the DOM */
    loading: PropTypes.bool,
    transparent: PropTypes.bool,
    variant: PropTypes.oneOf([
        loadingAnimationVariants.primary,
        loadingAnimationVariants.secondary,
    ]),
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "textPrimary",
        "textSecondary",
    ]),
}

Loading.defaultProps = {
    className: null,
    loading: true,
    variant: loadingAnimationVariants.primary,
    transparent: false,
    color: "secondary",
}

export default compose(
    withStyles(styles, { name: "Loading" }),
    React.memo,
)(Loading)
